import OrganizationLeave from '@/screens/OrganizationLeave';

export default function OrganizationLeaveRoute() {
  return <OrganizationLeave />;
}
